module.exports = __webpack_public_path__ + "media/images/btn_send_me_invoice-852d26419e16df6f10534a7a1b596bf6.gif";